import {
  CHAT_FOLDER_LIST_QUERY_KEY,
  CHAT_LIST_QUERY_KEY,
} from "@frontend-shared/constants";
import type { IMoveChatToFolderPayload } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

export const useMoveToFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IMoveChatToFolderPayload) =>
      chatApi.moveChatToFolder(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CHAT_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [CHAT_FOLDER_LIST_QUERY_KEY],
      });
    },
  });
};
